import { Card, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function OperationDetails() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const { state } = useLocation();
    const { operation_id } = state;
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        operation_id,
    });

    const {
        status: transactionDetailStatus,
        data: transactionDetailRes,
        refetch: fetchTransactionDetail,
    } = useQuery(
        `TransactionDetails${operation_id}`,
        async () => {
            return await HTTP("/dashboard/getPageTrackDetailsTable", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchTransactionDetail();
    }, []);

    useEffect(() => {
        fetchTransactionDetail();
    }, [formData]);

    useEffect(() => {
        if (transactionDetailStatus === "success") {
            const { data: scanData, total } = transactionDetailRes;
            setTotalRecords(total);
            setTableData(scanData);
        }
    }, [transactionDetailStatus, transactionDetailRes]);
    /* function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...formData, ...others };
        setFormData(updatedFormData);
    } */

    const columns = [
        {
            title: "Duration",
            dataIndex: "duration",
            key: "duration",
            // sorter: () => {},
        },
        {
            title: "Page",
            dataIndex: "page_name",
            key: "page_name",
            // sorter: () => {},
        },
    ];

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            {transactionDetailStatus === "loading" ||
            transactionDetailStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    handleTableChange={() => {}}
                    rowKey="page_name"
                    className="review-table"
                />
            )}
        </Card>
    );
}
export { OperationDetails };
